import React, { useEffect, useRef, useState } from "react";
import "../assets/css/TextVideo.css";
import engVideo from "../assets/video/heroengweb.mp4";
import engVideoMob from "../assets/video/heroengmob.mp4";
import arabVideo from "../assets/video/arabicweb.mp4";
import arabVideoMob from "../assets/video/arabicmob.mp4";
import { HiVolumeUp, HiVolumeOff } from "react-icons/hi";

const TextVideo = ({ language }) => {
  const textRef = useRef(null);
  const videoRef = useRef(null);
  const stickyRef = useRef(null);
  const audioBtnRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  // ✅ Toggle audio
  const handleAudioToggle = async () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = !video.muted;
    setIsMuted(video.muted);

    try {
      await video.play();
    } catch (err) {
      console.warn("Autoplay blocked:", err);
    }
  };

  // ✅ Choose video based on language
  const getVideoSources = () => {
    if (language === "ar") {
      return { web: arabVideo, mob: arabVideoMob };
    }
    return { web: engVideo, mob: engVideoMob };
  };

  const { web: desktopVideo, mob: mobileVideo } = getVideoSources();

  // ✅ Reload video whenever language changes
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.pause();
      // Remove all sources
      while (video.firstChild) video.removeChild(video.firstChild);

      // Add new sources
      const desktopSource = document.createElement("source");
      desktopSource.src = desktopVideo;
      desktopSource.type = "video/mp4";
      desktopSource.setAttribute("media", "(min-width: 768px)");
      video.appendChild(desktopSource);

      const mobileSource = document.createElement("source");
      mobileSource.src = mobileVideo;
      mobileSource.type = "video/mp4";
      mobileSource.setAttribute("media", "(max-width: 767px)");
      video.appendChild(mobileSource);

      video.load();
      video.play().catch(() => console.warn("Autoplay blocked"));
    }
  }, [desktopVideo, mobileVideo]);

  // ✅ Scroll effect (same as before)
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const section = document.querySelector(".blend-section");
      if (!section) return;

      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const viewportHeight = window.innerHeight;

      const startPoint = sectionTop - viewportHeight * 0.6;
      const endPoint = sectionTop + sectionHeight * 0.7;
      const progress = Math.min(Math.max((scrollY - startPoint) / (endPoint - startPoint), 0), 1);

      const scale = 1 + progress * 30.5;
      const opacity = 1 - progress;

      if (textRef.current) {
        textRef.current.style.transform = `scale(${scale})`;
        textRef.current.style.opacity = opacity;
      }

      if (stickyRef.current) {
        const height = 33 + progress * 157;
        stickyRef.current.style.height = `${height}vh`;

        const video = videoRef.current;

        if (height >= 100) {
          if (textRef.current) textRef.current.style.display = "none";
          if (audioBtnRef.current) audioBtnRef.current.style.display = "block";
        } else {
          if (textRef.current) textRef.current.style.display = "flex";
          if (audioBtnRef.current) audioBtnRef.current.style.display = "none";
        }

        const sectionBottom = sectionTop + sectionHeight;
        if (scrollY + viewportHeight > sectionTop && scrollY < sectionBottom) {
          if (video && video.currentTime > 0.5) video.currentTime = 0;
        }

        if (scrollY + viewportHeight < sectionTop || scrollY > sectionBottom) {
          if (video && !video.muted) {
            video.muted = true;
            setIsMuted(true);
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="blend-section">
      <div className="blend-sticky" ref={stickyRef}>
        <video className="blend-video" ref={videoRef} loop autoPlay playsInline muted={isMuted} />

        <div className="blend-text" ref={textRef}>
          <h1>CAPTAINX</h1>
        </div>

        <button ref={audioBtnRef} className="audio-toggle" onClick={handleAudioToggle}>
          {isMuted ? <HiVolumeOff size={22} /> : <HiVolumeUp size={22} />}
        </button>
      </div>
    </section>
  );
};

export default TextVideo;
